import { getPassoBadges, type PassoBadge } from '@utils/passoBadges.js'
import type { PassoJornada } from '@content/jornada.js'

const KIND_CLASS: Record<PassoBadge['kind'], string> = {
  ferramenta: 'cf3-badge cf3-badge--ferramenta',
  checklist: 'cf3-badge cf3-badge--checklist',
  referencia: 'cf3-badge cf3-badge--referencia',
  critico: 'cf3-badge cf3-badge--critico',
  camada: 'cf3-badge cf3-badge--camada',
}

interface Props {
  passo: PassoJornada
  compact?: boolean
}

export function PassoBadgeList({ passo, compact }: Props) {
  const badges = getPassoBadges(passo)
  const visible = compact ? badges.filter((b) => b.kind !== 'camada').slice(0, 2) : badges

  return (
    <span className='cf3-badge-list'>
      {visible.map((b) => (
        <span key={`${b.kind}-${b.label}`} className={KIND_CLASS[b.kind]}>
          {b.label}
        </span>
      ))}
    </span>
  )
}
